<template>
  <v-card class="light-blue lighten-5 elevation-7" :class="{'mobile-card': $vuetify.breakpoint.xsOnly}">
    <v-card-text>
      <p class="fix-margin-print fonte">
        <b>RECLAMAÇÕES / ORIENTAÇÕES:</b> Corregedoria Geral da Justiça (69) 3309-6024 - E-mail: depex@tjro.jus.br
      </p>
      <p class="fix-margin-print fonte">
        <b>OUVIDORIA:</b> 0800-647-7077 ou (69) 3309-6649
      </p>

      <v-divider light></v-divider>

      <p class="fix-margin-print fonte">
        <b>CONSULTA DA VALIDADE DO SELO DIGITAL DE FISCALIZAÇÃO:</b>
      </p>
      <p class="fix-margin-print fonte">
        <a href="https://www.tjro.jus.br/consultaselo/">www.tjro.jus.br/consultaselo/</a>
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: "AlertaDivergencia",
    props: {},
    data: function () {
      return {};
    }
  }
</script>

<style scoped>
  .fix-margin-print{
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .fonte{
    font-size: 0.875em;
  }
</style>



// WEBPACK FOOTER //
// src/components/detalhes/AlertaDivergencia.vue